import script from "./TressCheckoutAddressViewerDouble.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressCheckoutAddressViewerDouble.vue?vue&type=script&setup=true&lang=ts"

import "./TressCheckoutAddressViewerDouble.vue?vue&type=style&index=0&id=4f3fe9b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3fe9b4"]])

export default __exports__